import { type Person, PersonRole } from './person';

export enum JumpStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
};

export type Boost = {
    id: string;
    jumpId: string;             // foreign key on related table "jumps"
    email: string;
    points: number;
    created: string;            // UTC created date in ISO8601 format
    updated: string;            // UTC updated date in ISO8601 format
}

export type JumpMember = Person;

export type JumpDocument = {
    id: string,
    title: string
}

export type Link = {
    key: string;
    value: string;
}

export type JumpSummary = {
    id?: string;
    competitionId?: string;      // foreign key on related table "competitions"
    status?: JumpStatus;
    name?: string;
    points?: number;
}

export interface Jump extends JumpSummary {
    creator?: string;
    description?: string;
    favorite?: string,              // ID of "starred" asset
    team?: Array<string>;           // from related table persons where persons.role = 'JUMP_ADMIN'
    reviewers?: Array<string>;      // from related table persons where persons.role = 'REVIEWER'
    userRole?: PersonRole;      // role of user viewing jump
    documents?: Array<JumpDocument>,
    categories?: Array<string>; // stored as JSON in the database
    links?: Array<Link>;        // stored as JSON in the database
    created?: string;           // UTC created date in ISO8601 format
    updated: string;            // UTC updated date in ISO8601 format
}

export type JumpList = Array<Jump>;
